import {getToken} from "../../data/AuthTokenStorage";

export  default ()=>({
    loading:false,
    error:false,
    isLoggedIn:getToken(),
    errorsList:{},
    user:{}
})